import Phaser from 'phaser';
import { Colors } from "../consts/Colors";
import { Fonts } from "../consts/Fonts";
import DragManager from "../prefabs/DragManager";
import Card1 from "../prefabs/game1/Card1";
import Zone1 from "../prefabs/game1/Zone1";
import AbstractScene from "./AbstractScene";
import DeckFond from '../prefabs/DeckFond';
import Card2 from '../prefabs/game2/Card2';
import RoundedButton from '../prefabs/buttons/RoundedButton';
import ScoreContainer from '../prefabs/ScoreContainer';
import EndBoard from '../prefabs/EndBoard';

export default class Game1 extends AbstractScene {
    constructor() {
        super({
            key: "Game1"
        })
    }

    init(data) {
        this._init(data);

        this.config = this.cache.json.get('config')['game1']
        this.cardsConfig = [...Phaser.Utils.Array.Shuffle(this.config.cards)]
        console.log("config", this.cardsConfig)

        this.addDragManager();

        this.zonesPositions = [
            {x: 84 + 289/2, y: 337 + 151/2},
            {x: 449 + 289/2, y: 337 + 151/2},
            {x: 814 + 289/2, y: 337 + 151/2},
            {x: 1179 + 289/2, y: 337 + 151/2},
            {x: 1544 + 289/2, y: 337 + 151/2}
        ]

        this.score = {
            bravo: 0,
            mauvais: 0
        }

    }

    preload() {
        this._preload();
    }

    create(){
        // Ajout du fond
        this.bg = this.add.image(0, 0, 'background_0').setOrigin(0, 0);
        let bg2 = this.add.image(39, 779, 'info').setOrigin(0, 0);

        // Ajout du fond de pioche
        this.fondBleu = this.add.rexRoundRectangle(this.width -16, this.height - 16, 704, 317, {tl: 58}, Colors.Elmt.DarkBlue).setOrigin(1, 1)

        this.deckFond = new DeckFond(this, 1552, 905, {text: "Associez chaque calcul au ratio financier correspondant.", totalQuestions: this.cardsConfig.length});
        
        // Ajout des cartes
        this.currentQuestion = 0
        this.currentPhase = 1

        // On fait apparaitre la première carte
        this.nextCard();

        // Ajout des zones de drop
        this.addZones()

        // Ajout popup intro
        this.addPopup({
            text: "Vous allez devoir reconstituer en deux étapes le schéma final de la vidéo sur les ratios financiers.\n\n<class=\"regularOblique\">Dans cette première étape,\nassociez chaque formule de calcul\nau ratio financier correspondant.</class>",
            width: 752,
            height: 344,
            endFunc: ()=>{}
        })
    }

    addDragManager(){
        this.dragManager = new DragManager(this);
        this.dragManager.setOnDropFunc((draggedObject, dropZone) => {
            this.checkResult(draggedObject, dropZone)
        })
    }

    addZones(){
        for (let i = 0; i < this.zonesPositions.length; i++) {
            let zone = new Zone1(this, this.zonesPositions[i].x, this.zonesPositions[i].y, {zoneId: i, image: 'zone' + this.currentPhase});
            this.dragManager.addDropZone(zone, i);
        }
    }

    checkResult(draggedObject, dropZone){
        console.log("checkResult", draggedObject.dragId, dropZone.zoneId)

        // On vérifie le résultat du drop
        var isTrue = draggedObject.dragId === dropZone.zoneId;

        // Modif de la zone et de la carte en fonction du résultat
        if(isTrue) {
            draggedObject.setTrue()
            dropZone.setDone()

            if(draggedObject.firstDrop) {
                draggedObject.firstDrop = false
                this.score.bravo++
            }
        } else {
            dropZone.setFalse()
            if(draggedObject.setFalse)
                draggedObject.setFalse()

            if(draggedObject.firstDrop) {
                draggedObject.firstDrop = false
                this.score.mauvais++
            }
        }

        // Affichage de la correction
        const correction = isTrue ? draggedObject.cardData.explanation.correct : draggedObject.cardData.explanation.incorrect
        let endFunction;
        let buttonText = "Réessayer"

        if(isTrue && this.cardsConfig.length === 0) {
            endFunction = () => {
                draggedObject.setDone()
                this.addZoneInfo(draggedObject)
                this.deckFond.hideCorrection()
                this.nextPhase()
            }
            buttonText = "Terminer"
        }else if (isTrue) {
            endFunction = () => {
                draggedObject.setDone()
                this.addZoneInfo(draggedObject)
                this.deckFond.hideCorrection()
                this.nextCard()
            }
            buttonText = "Suivant"
        }else{
            endFunction = () => {
                this.deckFond.hideCorrection()
                this.dragManager.resetDraggable(draggedObject)
            }
        }

        this.deckFond.displayCorrection(isTrue, correction, buttonText, endFunction);

    }

    addZoneInfo(draggable){
        // Ajout image supp sur graphique
        if(this.currentPhase != 1) return // Pas d'info pour la phase 2
        if(draggable.dragId == 0) return // Pas d'info pour la zone 0

        let imageName = draggable.getName() + "_info"
        const position = this.zonesPositions[draggable.dragId]
        const image = this.add.image(position.x, 225, imageName).setOrigin(0.5, 0)
        image.setAlpha(0)

        this.tweens.add({
            targets: image,
            alpha: 1,
            duration: 300,
        })        
    }

    nextCard(x = 1408 + 289/2, y = 806+ 151/2){
        // On remet les zones de drop pour les cartes suivantes
        this.dragManager.resetDropZones();

        // On met à jour le numéro de question
        this.currentQuestion++;
        this.deckFond.setNumberQuestion(this.currentQuestion);

        if(this.currentPhase ===1)
            this.nextCardPhase1(x, y)
        else if(this.currentPhase ===2)
            this.nextCardPhase2(x, y)
    }

    nextCardPhase1(x = 1408 + 289/2, y = 806 + 151/2){
        // Ajout nouvelle carte
        let data = this.cardsConfig.pop();
        const card = new Card1(this, x, y, data);
        console.log("nextCard", data)
        this.dragManager.addDraggable(card, data.position);
    }

    nextCardPhase2(x = 1408 + 289/2, y = 806 + 151/2){
        // Ajout nouvelle carte
        let data = this.cardsConfig.pop();
        const card = new Card2(this, x, y, data);
        console.log("nextCard", data)
        this.dragManager.addDraggable(card, data.position);
    }

    // --- Partie 2 ----
    // On passe à la phase 2 du jeu, reinitialisation des cartes et des zones de drop
    nextPhase(){
        if(this.currentPhase === 1) {
            this.startPhase2()
        }else{
            this.endGame()
        }
    }

    startPhase2(){
        // Reset drag manager
        this.addDragManager()

        // Reset variables
        this.config = this.cache.json.get('config')['game2']
        this.cardsConfig = [...Phaser.Utils.Array.Shuffle(this.config.cards)]
        this.currentQuestion = 0
        this.currentPhase = 2

        this.zonesPositions = [
            {x: 134 + 247/2, y: 148 + 56/2},
            {x: 498 + 247/2, y: 148 + 56/2},
            {x: 862 + 247/2, y: 148 + 56/2},
            {x: 1226 + 247/2, y: 148 + 56/2},
            {x: 1590 + 247/2, y: 148 + 56/2}
        ]

        // Reset elements du fond
        this.bg.setTexture('background_1')
        this.deckFond.setTextInfo("Associez chaque objectif au ratio financier correspondant.")

        // Ajout nouvelles zones de drop
        this.addZones()

        // Ajout nouvelles cartes
        this.nextCard()

        // Ajout popup intro
        this.addPopup({
            text: "Bravo ! Vous avez correctement associé chaque formule de calcul au ratio financier correspondant.\n\nDans cette seconde étape, associez chaque objectif\nau ratio financier correspondant.",
            width: 1000,
            height: 400,
            endFunc: ()=>{}
        })

    }

    endGame(){
        // Efface le deck
        this.tweens.add({
            targets: this.deckFond,
            alpha: 0,
            duration: 300,
            onComplete: () => {
                this.deckFond.destroy()

                // Affiche le texte de fin
                this.addBravoText()
            }
        })
    }

    addBravoText(){
        this.bravoContainer = this.add.container(0, 0, [])

        const bravoText = this.add.text(this.fondBleu.x - this.fondBleu.width / 2, this.fondBleu.y - this.fondBleu.height + 61, "Bravo !", {
            font: "32px " + Fonts.MassiliaBold,
            color: Colors.Text.White,
            resolution: 2,
            align: 'center'
        }).setOrigin(0.5, 0)
        this.bravoContainer.add(bravoText)

        const bravoExplicationText = this.add.text(bravoText.x, bravoText.y + bravoText.height + 16, "Vous avez correctement associé\nchaque objectif au ratio financier\ncorrespondant.", {
            font: "22px " + Fonts.MassiliaRegular,
            color: Colors.Text.White,
            lineSpacing: 2,
            resolution: 2,
            align: 'center'
        }).setOrigin(0.5, 0)
        this.bravoContainer.add(bravoExplicationText)

        const button = new RoundedButton(this, bravoExplicationText.x, bravoExplicationText.y + bravoExplicationText.height + 34, {
            width: 334,
            height: 52,
            text: "Découvrir votre résultat",
            textColor: Colors.Text.White, 
            backgroundColor: Colors.Elmt.DarkBlue,
            hoverBackgroundColor: Colors.Elmt.Orange,
            strokeColor: Colors.Elmt.White,
            fontSize: "24px",
        })
        button.y += button.height / 2
        this.bravoContainer.add(button)

        button.setClickFunction(() => {
            this.input.setDefaultCursor('default')

            // Affiche le score + boutons de partage
            this.tweens.add({
                targets: this.bravoContainer,
                alpha: 0,
                duration: 300,
            })

            this.fondBleu.setRadius({tl: 0, tr: 0, bl: 0, br: 0})
            this.tweens.add({
                targets: this.fondBleu,
                width: this.width,
                duration: 300,
                onComplete: () => {
                    this.displayResult()
                }
            })
        })
    }

    displayResult(){
        const endBoard = new EndBoard(this, 0, this.fondBleu.y - this.fondBleu.height, {scoreBravo: this.score.bravo, scoreMauvais: this.score.mauvais})        
    }
}